module.exports = __webpack_public_path__ + "img/logo_golf_col_color.4f04b8e3.png";